export default {
	/**
	 * CSS id for cart container element
	 * @const
	 * @type {string}
	 * @default
	 */
	POST_LOGIN_HASH_NAME: 'postLoginHash',
	CUSTOM_LOGIN_TRIGGERED_NAME: 'customLoginTriggered',
	/**
	 * Should the client prevent the server from timing out inactive sessions?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	TICKLE_SESSION: false,
};
